// This is where you overide basic theme of ant design
// change will be moved to the useToken

import type { ThemeConfig } from 'antd';

const defaultTheme: ThemeConfig = {
  token: {
    fontFamily: "'Roboto', sans-serif",
    colorPrimary: getComputedStyle(document.documentElement).getPropertyValue(
      '--color-primary',
    ),
  },
  components: {
    Typography: {
      fontFamilyCode: "'Nunito', sans-serif",
    },
    Button: {
      primaryShadow: '0',
      defaultShadow: '0',
      dangerShadow: '0',
    },
    Form: {
      itemMarginBottom: 0,
      verticalLabelPadding: 0,
    },
    Card: {
      bodyPadding: 0,
    },
  },
} satisfies ThemeConfig;

export default defaultTheme;
